<template lang="pug">
  .InfiniteScrollLoader
    span.InfiniteScrollLoader_diamond
    span.InfiniteScrollLoader_diamond
    span.InfiniteScrollLoader_diamond
</template>

<script>

export default {}

</script>

<style lang="stylus" scoped>

.InfiniteScrollLoader
  margin 0 auto
  display: flex
  align-item center
  justify-content: center
  
  @keyframes diamond {
    0% {
      opacity: .2
      transform: rotateZ(-45deg) scale(1)
    }
    10% {
      opacity: .5
      transform: rotateZ(-45deg) scale(1.5)
    }
    20% {
      opacity: .9
      transform: rotateZ(-45deg) scale(1)
    }
    55% {
      opacity: .9
      transform: rotateZ(-45deg) scale(1)
    }
    65% {
      opacity: .5
      transform: rotateZ(-45deg) scale(1.5)
    }
    75% {
      opacity: .2
      transform: rotateZ(-45deg) scale(1)
    }
    100% {
      opacity: .2
      transform: rotateZ(-45deg) scale(1)
    }
  }
  
  &_diamond
    display: block
    margin 0 8px
    width 12px
    height @width
    background-color #33312E
    transform: rotateZ(-45deg)
    $animation_speed = 1.5s
    animation: diamond $animation_speed infinite
    
    &:nth-child(3n+2)
      animation-delay ($animation_speed*0.075)
      
    &:nth-child(3n+3)
      animation-delay ($animation_speed*0.075*2)

</style>